//@flow
import api from '../Utils/apiBuilder';
import Constants from '../constants';

export default {
  getCreditCards() {
    api('creditcards')
      .get()
      .dispatch(Constants.GET_CREDIT_CARDS_SUCCESS);
  },

  // add a credit card/payment method
  addCard(data:Object) {
    data.is_default = true;

    return api('creditcards')
      .post(data)
      .dispatch(Constants.ADD_CREDIT_CARD_SUCCESS);
  },
};
